import React, { FC, useEffect, useRef, useState } from 'react';
import { addComma } from 'src/utils/common';
import { preworkDataStore, checkRequired } from 'src/store/preworkInfo';
import InputBox from 'src/components/atoms/input/DefInputBox';

interface Props {
  data: any;
  type?: string;
}
const GridList: FC<Props> = ({ type = '', data }) => {
  const preworkPayload = preworkDataStore((state: any) => state.payload);
  const bindPreworkPayload = preworkDataStore((state: any) => state.bindPayload);
  const inpStatus = type === 'list' ? '_read' : '';

  const inpChangeEvt = (e: React.ChangeEvent<HTMLInputElement>, key: string) => {
    bindPreworkPayload({ ...preworkPayload, [key]: e.target.value });
  };
  const inpChangeNumberEvt = (e: React.ChangeEvent<HTMLInputElement>, key: string) => {
    const value: any = e.target?.value.replace(/[^0-9]/g, ''); // 숫자만 허용
    bindPreworkPayload({ ...preworkPayload, [key]: Number(value) });
  };
  const labelStyle = { width: '170px', color: '#777', fontSize: '13px' };
  const boxStyle = { fontSize: '15px', fontWeight: '700' };

  return (
    <div className={['_comp_before_detail_content_div _active', inpStatus].join(' ')}>
      <div className="_row">
        <div className="_item _half" style={{ zIndex: 10 }}>
          <InputBox
            changeEvt={e => inpChangeNumberEvt(e, 'tsal_base')}
            label="급여"
            labelPosition="left"
            value={addComma(preworkPayload.tsal_base)}
            required={type !== 'list' ? checkRequired('tsal_base') : ''}
            placeholder="값을 입력하세요"
            labelStyleDef={labelStyle}
            styleDef={boxStyle}
            status={inpStatus}
            inpStyleDef={{ textAlign: 'right' }}
          />
        </div>
        <div className="_item_r _half" style={{ zIndex: 10 }}>
          <InputBox
            changeEvt={e => inpChangeNumberEvt(e, 'tsal_bonus')}
            label="상여"
            status={inpStatus}
            labelPosition="left"
            value={addComma(preworkPayload.tsal_bonus)}
            required={type !== 'list' ? checkRequired('tsal_bonus') : ''}
            placeholder="값을 입력하세요"
            labelStyleDef={labelStyle}
            styleDef={boxStyle}
            inpStyleDef={{ textAlign: 'right' }}
          />
        </div>
      </div>
      <div className="_row">
        <div className="_item _half" style={{ zIndex: 10 }}>
          <InputBox
            changeEvt={e => inpChangeNumberEvt(e, 'tsal_rbonus')}
            label="인정상여"
            status={inpStatus}
            labelPosition="left"
            value={addComma(preworkPayload.tsal_rbonus)}
            required={type !== 'list' ? checkRequired('tsal_rbonus') : ''}
            placeholder="값을 입력하세요"
            labelStyleDef={labelStyle}
            styleDef={boxStyle}
            inpStyleDef={{ textAlign: 'right' }}
          />
        </div>
        <div className="_item_r _half" style={{ zIndex: 10 }}>
          <InputBox
            changeEvt={e => inpChangeNumberEvt(e, 'tsal_stkopt')}
            label="주식매수선택권행사이익"
            status={inpStatus}
            labelPosition="left"
            value={addComma(preworkPayload.tsal_stkopt)}
            required={type !== 'list' ? checkRequired('tsal_stkopt') : ''}
            placeholder="값을 입력하세요"
            labelStyleDef={labelStyle}
            styleDef={boxStyle}
            inpStyleDef={{ textAlign: 'right' }}
          />
        </div>
      </div>
      <div className="_row">
        <div className="_item _half" style={{ zIndex: 10 }}>
          <InputBox
            changeEvt={e => inpChangeNumberEvt(e, 'tsal_esop_withdrawal')}
            label="우리사주조합인출금"
            status={inpStatus}
            labelPosition="left"
            value={addComma(preworkPayload.tsal_esop_withdrawal)}
            required={type !== 'list' ? checkRequired('tsal_esop_withdrawal') : ''}
            placeholder="값을 입력하세요"
            labelStyleDef={labelStyle}
            styleDef={boxStyle}
            inpStyleDef={{ textAlign: 'right' }}
          />
        </div>
        <div className="_item_r _half" style={{ zIndex: 10 }}>
          <InputBox
            changeEvt={e => inpChangeNumberEvt(e, 'tsal_excess_exec_retire')}
            label="임원 퇴직소득금액 한도초과"
            status={inpStatus}
            labelPosition="left"
            value={addComma(preworkPayload.tsal_excess_exec_retire)}
            required={type !== 'list' ? checkRequired('tsal_excess_exec_retire') : ''}
            placeholder="값을 입력하세요"
            labelStyleDef={labelStyle}
            styleDef={boxStyle}
            inpStyleDef={{ textAlign: 'right' }}
          />
        </div>
      </div>
      <div className="_row">
        <div className="_item _half" style={{ zIndex: 10 }}>
          <InputBox
            changeEvt={e => inpChangeNumberEvt(e, 'tsal_excess_invent_reward')}
            label="직무발명 보상금(한도초과분)"
            status={inpStatus}
            labelPosition="left"
            value={addComma(preworkPayload.tsal_excess_invent_reward)}
            required={type !== 'list' ? checkRequired('tsal_excess_invent_reward') : ''}
            placeholder="값을 입력하세요"
            labelStyleDef={labelStyle}
            styleDef={boxStyle}
            inpStyleDef={{ textAlign: 'right' }}
          />
        </div>
      </div>
    </div>
  );
};

export default GridList;
